import { render, staticRenderFns } from "./MyFollows.vue?vue&type=template&id=77cf3fc4&scoped=true"
import script from "./MyFollows.vue?vue&type=script&lang=js"
export * from "./MyFollows.vue?vue&type=script&lang=js"
import style0 from "./MyFollows.vue?vue&type=style&index=0&id=77cf3fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf3fc4",
  null
  
)

export default component.exports